module.exports = __webpack_public_path__ + "img/wz-8-7-3.0afdf84a.jpg";